import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import './BookingNoticeModal.css';

const STORAGE_KEY = 'hds_booking_notice_seen';

function BookingNoticeModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem(STORAGE_KEY);
    if (!seen) {
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, 'true');
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        setIsOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="booking-notice-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="booking-notice-title"
      aria-describedby="booking-notice-description"
    >
      <div
        className="booking-notice-modal__backdrop"
        onClick={handleClose}
        onKeyDown={(e) => e.key === 'Escape' && handleClose()}
        role="button"
        tabIndex={-1}
        aria-label="Close notice"
      />
      <div className="booking-notice-modal__content">
        <button
          type="button"
          className="booking-notice-modal__close"
          onClick={handleClose}
          aria-label="Close notice"
        >
          <FaTimes />
        </button>
        <h2 id="booking-notice-title" className="booking-notice-modal__title">
          Booking Notice
        </h2>
        <p id="booking-notice-description" className="booking-notice-modal__text">
          We are currently at capacity and unable to accept new reservations at this time. We appreciate your interest and invite you to check back in the future for availability.
        </p>
        <button
          type="button"
          className="booking-notice-modal__button"
          onClick={handleClose}
        >
          I understand
        </button>
      </div>
    </div>
  );
}

export default BookingNoticeModal;
